import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { StockService } from '../../services/stock.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/shared/snackbar/snackbar.service';
import { StoreStockLot } from '../../interfaces/stock.interface';

@Component({
  selector: 'app-stock-location-form',
  templateUrl: './stock-location-form.component.html',
  styleUrls: ['./stock-location-form.component.scss']
})
export class StockLocationFormComponent {
  @Input() stockData!: StoreStockLot;
  @Output() formSubmitted = new EventEmitter<boolean>();
  @Output() stepBackEmitter = new EventEmitter<void>();


  private readonly destroy$ = new Subject<void>();

  locationForm: FormGroup;
  isLoading = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly stockService: StockService,
    private readonly translate: TranslateService,
    private readonly snackbarService: SnackbarService
  ) {
    this.locationForm = this.createForm();

  }

  ngOnInit(): void {
    const locationsFA = this.locationForm.get('locations') as FormArray;
    locationsFA.clear();
    this.stockData?.locations?.forEach(loc => {
      locationsFA.push(this.fb.control(loc));
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get locations() {
    return this.locationForm.get('locations') as FormArray;
  }
  get locationText() {
    return this.locationForm.get('locationText') as FormControl;
  }

  addLocation() {
    if (this.locationText?.value?.trim() && !this.locations.value.includes(this.locationText?.value)) {
      this.locations.push(this.fb.control(this.locationText?.value, Validators.required));
      this.locationText.setValue("");
    }

  }

  removeLocation(index: number) {
    this.locations.removeAt(index);
  }

  private createForm(): FormGroup {
    return this.fb.group({
      locations: this.fb.array([]),
      locationText: [''],
    });
  }

  save(): void {
    if (this.locationForm.valid && !this.isLoading) {
      const formValue = this.locationForm.value;


      // this.stockService.updateLotLocation(this.stockData.lotId, formValue.locations)
      //   .pipe(takeUntil(this.destroy$))
      //   .subscribe({
      //     next: () => {
      //       this.isLoading = false;
      //       this.formSubmitted.emit(true);
      //     },
      //     error: (error) => {
      //       console.error('Error updating stock quantity:', error);
      //       this.isLoading = false;
      //     }
      //   });
    } else {
      this.locationForm.markAllAsTouched();
    }
  }

  goBack(): void {
    this.stepBackEmitter.emit();
  }
}
